<template>
  <div class="innerPage">
    <div class="innerPageHead">
      <div class="innerPageTitle">
        <h2>{{ $t("TopNav02") }}</h2> 
      </div>
      <div class="innerPagePagination">
        <b-container>
          <b-breadcrumb :items="items"></b-breadcrumb>
        </b-container>
      </div>
    </div>

    <div class="interPageMainContain">
      <b-container>
          <h3 class="font-weight-bold">{{ $t("about_01") }}</h3>
          <h4 class="font-weight-bold pb-1">{{ $t("about_02") }}</h4>
          <p>{{ $t("about_03") }}</p>
          <p>{{ $t("about_04") }}</p>
          <p>{{ $t("about_05") }}</p>
          <div class="check-list">
              <div class="item">
                  <div class="icon">✓</div>
                  <div>{{ $t("about_06") }}</div>
              </div>
              <div class="item">
                  <div class="icon">✓</div>
                  <div>{{ $t("about_07") }}</div>
              </div>
              <div class="item">
                  <div class="icon">✓</div>
                  <div>{{ $t("about_08") }}</div>
              </div>
              <div class="item">
                  <div class="icon">✓</div>
                  <div>{{ $t("about_09") }}</div>
              </div>
              <div class="item">
                  <div class="icon">✓</div>
                  <div>{{ $t("about_10") }}</div>
              </div>
          </div>
          <p>{{ $t("about_11") }}</p>

          <h3 class="font-weight-bold pb-1 pt-3">{{ $t("about_12") }}</h3>
          <div class="theme-group">
            <b-row align-h="center" cols="1" cols-lg="3">
              <b-col>
                <div class="theme-item">
                  <h4 class="font-weight-bold">{{ $t("about_13") }}</h4>
                  <p>{{ $t("about_14") }}</p>
                </div>
              </b-col>
              <b-col>
                <div class="theme-item">
                  <h4 class="font-weight-bold">{{ $t("about_15") }}</h4>
                  <p>{{ $t("about_16") }}</p>
                </div>
              </b-col>
              <b-col>
                <div class="theme-item">
                  <h4 class="font-weight-bold">{{ $t("about_17") }}</h4>
                  <p>{{ $t("about_18") }}</p>
                </div>
              </b-col>
              <b-col>
                <div class="theme-item">
                  <h4 class="font-weight-bold">{{ $t("about_19") }}</h4>
                  <p>{{ $t("about_20") }}</p>
                </div>
              </b-col>
              <b-col>
                <div class="theme-item">
                  <h4 class="font-weight-bold">{{ $t("about_21") }}</h4>
                  <p>{{ $t("about_22") }}</p>
                </div>
              </b-col>


            </b-row>
          </div>

          <!-- <h3 class="font-weight-bold pb-1 pt-3">{{ $t("about_gift_title") }}</h3>
          <b-row align-v="center">
            <b-col lg="2">
                <b-img
                  :src="require('@/assets/imgs/img_gift01.png')"
                  fluid
                  alt="bag"
                ></b-img>
            </b-col>
            <b-col lg="8">
              <h4 class="font-weight-bold text-warning">{{ $t("about_gift_1-1") }}</h4>
                <p><strong class="red">{{ $t("about_gift_1-2") }}</strong> {{ $t("about_gift_1-3") }}</p>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col lg="2">
                <b-img
                  :src="require('@/assets/imgs/img_gift02.png')"
                  fluid
                  alt="bag"
                ></b-img>
            </b-col>
            <b-col lg="8">
              <h4 class="font-weight-bold text-warning">{{ $t("about_gift_2-1") }}</h4>
                <p>{{ $t("about_gift_2-2") }}</p>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col lg="2">
                <b-img
                  :src="require('@/assets/imgs/img_gift03.png')"
                  fluid
                  alt="bag"
                ></b-img>
            </b-col>
            <b-col lg="8">
              <h4 class="font-weight-bold text-warning">{{ $t("about_gift_3-1") }}</h4>
                <p>{{ $t("about_gift_3-2") }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2">

            </b-col>
            <b-col lg="7">
                <div>{{ $t("about_gift_4") }}</div>
                <div>{{ $t("about_gift_5") }}</div>
                <div>{{ $t("about_gift_6") }}</div>
            </b-col>
          </b-row> -->



      </b-container>

    </div>    
    <ul id="myMenu">
      <li>
        <b-link to="/" tooltip="首頁" flow="left"
          ><span class="icon-home" :title="$t('rightNav01')"></span
          ><span class="sr-only">{{ $t("TopNav01") }}</span>
        </b-link>
      </li>
      <li>
        <a
          href="https://www.surveycake.com/s/DrWBR"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-user-plus"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        navigationActive: [],
        items: [
          {
            text: this.$t("TopNav01") ,
            href: "#/",
          },
          {
            text: this.$t("TopNav02") ,
            active: true,
          },
        ],
      };
    },
    mounted() {
      window.scrollTo(0, 0);
      window.addEventListener("scroll", this.updateScroll);
    },
    methods: {
      updateScroll() {
        this.navigationActive = [false, false, false, false];
        let scroll = Math.round(window.scrollY);
        if (scroll < this.pageHeight2) {
          this.navigationActive[0] = true;
        } else if (scroll >= this.pageHeight2 && scroll < this.pageHeight3) {
          this.navigationActive[1] = true;
        } else if (scroll >= this.pageHeight3 && scroll < this.pageHeight4) {
          this.navigationActive[2] = true;
        } else if (scroll >= this.pageHeight4) {
          this.navigationActive[3] = true;
        }
        this.nowScroll = scroll;
      },
    },
  };
</script>
<style lang="scss"></style>
